import { CircularProgress } from "@material-ui/core";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { Table, Dropdown, Modal, Button } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import Checkbox from "../../../../components/Checkbox";
import BasicPagination from "../../../pagination/BasicPagination";
import { useIsAccessAllow } from "../../../users/redux";
import { showSuccessSnackbar } from "../../../snackBar/snackBar.action";
import Select from "react-select";
import axios from "axios";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import "./modernTable.scss";
import CallDetailsModal from "../../components/CallDetailsModal";
import CallDetailsButtonWithStatus from "../../../../components/CallDetailsButtonWithStatus";
import { getFailureLabel } from "../../../../utils/callFailure.util";
import { getSuccessDescriptor, normalizeStatusText } from "../../../../utils/callSuccess.util";
import {
  newLeadsAction,
  deleteNewLeadAsync,
  deleteSelectedNewLeadsAsync,
  getAllNewLeadsAsync,
  startNewLeadCallAsync,
  bulkCallNewLeadsAsync,
} from "../../redux";



// Helper function to get initials from name
const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(" ");
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

// Sort indicator component
const SortIndicator = () => (
  <span className="sort-indicator">
    <svg viewBox="0 0 10 10" fill="currentColor">
      <path d="M5 0L3 2h4L5 0z" />
      <path d="M5 10L7 8H3l2 2z" />
    </svg>
  </span>
);

// Main component for displaying new leads table
const NewLeadsTable = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [checkedVal, setCheckedVal] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [recallTextFind, setRecallTextFind] = useState("");
  const [callStatusCache, setCallStatusCache] = useState({}); // Cache for call statuses
  const [openDropdownId, setOpenDropdownId] = useState(null); // Track which dropdown is open
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);
  const [callDetailsLeadId, setCallDetailsLeadId] = useState(null);
  const [isBulkCallConfirmOpen, setIsBulkCallConfirmOpen] = useState(false);
  const [isBulkCallLoading, setIsBulkCallLoading] = useState(false);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null); // store lead or "bulk"
  const [isStartCallConfirmOpen, setIsStartCallConfirmOpen] = useState(false);
  const [isStartCallLoading, setIsStartCallLoading] = useState(false);
  const [startCallLeadId, setStartCallLeadId] = useState(null);

  const { searchBy, searchText, audioType, isLoading, coldLeadsList, skip, limit: stateLimit, batchFilter, fromDateFilter, toDateFilter, leadType, callOutcomeFilter, companyNameFilter, createdByFilter } = useSelector(
    (state) => state.newDataCall,
    shallowEqual
  );

  // Ensure default page size is 50
  const limit = stateLimit || 50;

  const { user: loggedInUser } = useSelector(
    (state) => state.auth,
    shallowEqual
  );

  const { adminBaseURL } = useSelector(
    (state) => state.environnment.environmentLists,
    shallowEqual,
  );

  // Fetch RECALL_TEXT_FIND setting
  // useEffect(() => {
  //   let mounted = true;
  //   (async () => {
  //     try {
  //       const { data } = await axios({
  //         method: "GET",
  //         url: `${process.env.REACT_APP_HOST}${adminBaseURL}/settings`,
  //         headers: { "Content-Type": "application/json" },
  //       });
  //       if (!mounted) return;
  //       if (data?.code === 200 && data?.data?.RECALL_TEXT_FIND) {
  //         setRecallTextFind(data.data.RECALL_TEXT_FIND);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch RECALL_TEXT_FIND:", error);
  //     }
  //   })();
  //   return () => {
  //     mounted = false;
  //   };
  // }, [adminBaseURL]);

  const pageSizeOptions = [
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 150, label: "150" },
    { value: 200, label: "200" },
  ];

  const defaultPageSize =
    pageSizeOptions.find((option) => option.value === limit) ||
    pageSizeOptions[0];

  const changePageSize = (option) => {
    dispatch(newLeadsAction.setLimit(option.value));
    dispatch(newLeadsAction.setNewLeadsBatchNumber(0));
  };

  // Helper functions for call status (from CallDetailsTabs.js)
  const formatTime = useCallback((ts) => {
    if (!ts) return "-";
    try {
      return new Date(ts).toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      return "-";
    }
  }, []);

  const formatDate = useCallback((ts) => {
    if (!ts) return "-";
    try {
      const d = new Date(ts);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    } catch (e) {
      return "-";
    }
  }, []);

  // const normalizeStatusText = useCallback((value) => {
  //   if (!value || typeof value !== "string") return "";
  //   const cleaned = value.replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim();
  //   if (!cleaned) return "";
  //   return cleaned
  //     .split(" ")
  //     .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
  //     .join(" ");
  // }, []);



  // const getTranscriptSummary = useCallback((item) => {
  //   if (!item) return "";
  //   const transcript = item.elevenlabs_call_transcription || item.call_transcript;
  //   if (!transcript) return "";
  //   try {
  //     const parsed = typeof transcript === "string" ? JSON.parse(transcript) : transcript;
  //     if (parsed && typeof parsed.summary === "string") {
  //       return parsed.summary;
  //     }
  //   } catch (err) { }
  //   return "";
  // }, []);

  // const checkAgentMessageForRecallText = useCallback(
  //   (item, recallText) => {
  //     if (!item || !recallText || !recallText.trim()) return false;

  //     const transcript = item.elevenlabs_call_transcription || item.call_transcript;
  //     if (!transcript) return false;

  //     try {
  //       const parsed = typeof transcript === "string" ? JSON.parse(transcript) : transcript;
  //       const transcriptRows = parsed?.transcript_rows;

  //       if (Array.isArray(transcriptRows) && transcriptRows.length > 0) {
  //         const agentMessages = transcriptRows
  //           .filter((row) => row?.role === "agent" && row?.message)
  //           .map((row) => (row.message || "").toLowerCase());

  //         const recallTextLower = recallText.toLowerCase().trim();
  //         return agentMessages.some((msg) => msg.includes(recallTextLower));
  //       }
  //     } catch (err) {
  //       // Error parsing transcript
  //     }

  //     return false;
  //   },
  //   []
  // );

  // const getSuccessDescriptor = useCallback(
  //   (item) => {
  //     if (!item) {
  //       return "Call";
  //     }

  //     // Rule 1: Check for no-answer failure
  //     if (
  //       item.type === "call_initiation_failure" &&
  //       (item.failure_reason === "no-answer" || item.failure_reason === "no answer")
  //     ) {
  //       return "Not Concluded";
  //     }

  //     // Rule 2: Check for voicemail detection
  //     if (item.voicemail_detection === true) {
  //       return "Not Concluded";
  //     }

  //     // Rule 3: Check elevenlabs_analysis
  //     if (item.elevenlabs_analysis) {
  //       try {
  //         const analysis =
  //           typeof item.elevenlabs_analysis === "string"
  //             ? JSON.parse(item.elevenlabs_analysis)
  //             : item.elevenlabs_analysis;

  //         const callScheduleEval =
  //           analysis?.evaluation_criteria_results?.call_schedule_evaluation?.result;
  //         const clientEngagementEval =
  //           analysis?.evaluation_criteria_results?.client_engagement_evaluation?.result;

  //         if (callScheduleEval && clientEngagementEval) {
  //           // Normalize values for comparison (trim whitespace and convert to lowercase)
  //           const normalizedCallSchedule = String(callScheduleEval).trim().toLowerCase();
  //           const normalizedClientEngagement = String(clientEngagementEval).trim().toLowerCase();

  //           // If both evaluations have the same result
  //           if (normalizedCallSchedule === "success" && normalizedClientEngagement === "success") {
  //             return "Call Concluded";
  //           } else if (normalizedCallSchedule === "failure" && normalizedClientEngagement === "failure") {
  //             return "Not Interested";
  //           } else if (
  //             normalizedCallSchedule === "failure" &&
  //             normalizedClientEngagement === "success"
  //           ) {
  //             return "Not Interested";
  //           } else {
  //             return "Not Concluded";
  //           }
  //         }
  //       } catch (error) {
  //         // Error parsing elevenlabs_analysis - continue to fallback
  //       }
  //     }

  //     // Fallback to other status fields
  //     const summary = getTranscriptSummary(item);
  //     if (summary) {
  //       const summaryLc = summary.toLowerCase();
  //     }

  //     const message = normalizeStatusText(
  //       item?.elevenlabs_message || item?.status_message || item?.call_status_message
  //     );
  //     if (message) return message;

  //     const typeDescriptor = normalizeStatusText(item?.type || item?.callOutcome || item?.status);
  //     if (typeDescriptor) return typeDescriptor;

  //     return "Call";
  //   },
  //   [getTranscriptSummary, normalizeStatusText]
  // );

  // Determine if call item is a failure
  const isFailureRecord = useCallback((item) => {
    return (
      item &&
      typeof item.type === "string" &&
      (item.type === "call_initiation_failure" || item.type === "call_not_connect") &&
      (String(item.call_initiation_failure || "").trim() !== "" || item.type === "call_not_connect")
    );
  }, []);

  // Get Call Outcome based on status and item
  // const getCallOutcome = useCallback((item, status) => {
  //   if (!item || !status) return "-";

  //   const statusLower = status.toLowerCase();

  //   // Rule 1: If voicemail_detection is true, outcome is "Not Concluded"
  //   if (item.voicemail_detection === true) {
  //     return "Not Concluded";
  //   }

  //   // Rule 2: If status is from failure labels, outcome is "Not Concluded"
  //   const failureStatuses = [
  //     "busy call",
  //     "no answer call",
  //     "call cancel",
  //     "call not receive",
  //     "call failed"
  //   ];

  //   if (failureStatuses.includes(statusLower)) {
  //     return "Not Concluded";
  //   }

  //   // Rule 3: If status is from getSuccessDescriptor, outcome is same as status
  //   // This includes: "Call Concluded", "Not Concluded", "Not Interested", or other statuses
  //   // Statuses like "Not Interested" should display as-is in Call Outcome
  //   return status;
  // }, []);

  const getCallOutcome = useCallback((item, status, isFailureRecord) => {
    if (!item || !status) return "-";

    // Priority 1: Use elevenlabs_call_outcome_status from database if available
    // This field comes from the cold_leads_calling_ai table
    if (item.elevenlabs_call_outcome_status) {
      return item.elevenlabs_call_outcome_status;
    }
    if (isFailureRecord) {
      return "Not Concluded";
    }

    return item.elevenlabs_call_outcome_status;
  }, []);
  // Get call status for a lead
  const getCallStatus = useCallback(
    async (lead) => {
      if (!lead?._id) return null;
      const leadId = lead._id;
      // Check cache first
      if (callStatusCache[leadId]) {
        return callStatusCache[leadId];
      }

      try {
        const items = lead.call_ai || lead.callAi || lead.callRecords || [];
        const latestCall = Array.isArray(items) && items.length > 0 ? items[items.length - 1] : null;

        if (latestCall) {
          const isFailure = isFailureRecord(latestCall);
          const status = isFailure
            ? getFailureLabel(latestCall)
            : getSuccessDescriptor(latestCall);

          // Get Call Outcome based on status and item
          const outcome = getCallOutcome(latestCall, status, isFailure);
          const statusData = {
            status,
            outcome,
            date: formatDate(latestCall?.createdOn),
            time: formatTime(latestCall?.createdOn),
            isFailure,
          };
          setCallStatusCache((prev) => ({ ...prev, [leadId]: statusData }));
          return statusData;
        }
      } catch (error) {
        // Failed to process call status
      }

      return null;
    },
    [formatDate, formatTime, getFailureLabel, getCallOutcome, isFailureRecord, callStatusCache]
  );

  // Filter leads based on call outcome filter
  const filteredLeads = useMemo(() => {
    if (!coldLeadsList?.records) return [];
    // Since API now handles call_outcome_status filtering, just return all records
    return coldLeadsList.records;
  }, [coldLeadsList?.records]);

  // Fetching is now entirely managed by the parent component (coldLeads.js)
  // via the refreshColdLeadsList Redux state flag.
  // Remove blocked leads from selectedIds when data changes
  useEffect(() => {
    const recordsToCheck = filteredLeads.length > 0 ? filteredLeads : (coldLeadsList?.records || []);
    if (recordsToCheck && selectedIds.length > 0) {
      const blockedIds = recordsToCheck
        .filter((item) => item?.leadType === "Blocked")
        .map((item) => item?._id)
        .filter(Boolean);

      if (blockedIds.length > 0) {
        const hasBlockedSelected = selectedIds.some((id) => blockedIds.includes(id));
        if (hasBlockedSelected) {
          setSelectedIds((prev) => prev.filter((id) => !blockedIds.includes(id)));
          if (checkedVal && selectedIds.length === blockedIds.length) {
            setCheckedVal(false);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filteredLeads, coldLeadsList]);

  // Log cold leads data when it changes
  useEffect(() => {
    if (coldLeadsList?.records && coldLeadsList.records.length > 0) {
      // Process cold leads data
    }
    // Clear call status cache when data changes so tooltips show fresh data

    // 26-02-2026 Start listing latest data
    setCallStatusCache({});
    // 26-02-2026 End listing latest data
  }, [coldLeadsList]);

  const onPageChange = (pageIndex) => {
    const nextPage = Math.max(0, pageIndex);
    dispatch(newLeadsAction.setNewLeadsBatchNumber(nextPage));
  };

  const onViewClick = (data) => {
    history.push(`/new-data-call/view/${data?._id}`);
  };

  const openCallDetailsModal = (data) => {
    if (!data?._id) return;
    setCallDetailsLeadId(data._id);
    setIsCallModalOpen(true);
  };

  const closeCallDetailsModal = () => {
    setIsCallModalOpen(false);
  };

  const onCallDetailsClick = (data) => {
    openCallDetailsModal(data);
  };

  const onCallDetailsPageClick = (data) => {
    if (!data?._id) return;
    window.open(`/new-data-call/call-details/${data._id}`, "_blank");
  };

  const onStartCallClick = (data) => {
    if (!data?._id) return;
    setStartCallLeadId(data._id);
    setIsStartCallConfirmOpen(true);
  };

  const handleStartCallConfirm = async () => {
    if (!startCallLeadId) return;

    setIsStartCallLoading(true);
    try {
      const result = await dispatch(startNewLeadCallAsync(startCallLeadId));
      if (result?.success) {
        // Refresh the list after successful call initiation
        dispatch(getAllNewLeadsAsync(searchBy, searchText, audioType, batchFilter, fromDateFilter, toDateFilter, leadType, createdByFilter, "createdOn", "desc", callOutcomeFilter, companyNameFilter));
      }
    } finally {
      setIsStartCallLoading(false);
      setIsStartCallConfirmOpen(false);
      setStartCallLeadId(null);
    }
  };

  const handleStartCallCancel = () => {
    if (isStartCallLoading) return;
    setIsStartCallConfirmOpen(false);
    setStartCallLeadId(null);
  };

  const onBulkCallClick = () => {
    if (!selectedIds.length) {
      return;
    }

    setIsBulkCallConfirmOpen(true);
  };

  const handleBulkCallConfirm = async () => {
    setIsBulkCallLoading(true);
    try {
      // Get current time when API call is initiated
      const result = await dispatch(bulkCallNewLeadsAsync(selectedIds));
      if (result?.success) {
        setCheckedVal(false);
        setSelectedIds([]);
        // Refresh the list after successful bulk call initiation
        dispatch(getAllNewLeadsAsync(searchBy, searchText, audioType, batchFilter, fromDateFilter, toDateFilter, leadType, createdByFilter, "createdOn", "desc", callOutcomeFilter, companyNameFilter));
      }
      setIsBulkCallConfirmOpen(false);
    } catch (error) {
      console.error("Bulk call error:", error);
    } finally {
      setIsBulkCallLoading(false);
    }
  };

  const handleBulkCallCancel = () => {
    setIsBulkCallConfirmOpen(false);
    setIsBulkCallLoading(false);
  };



  const onDeleteClick = (data) => {
    if (!data?._id) return;
    setDeleteTarget({ type: "single", leadId: data._id });
    setIsDeleteConfirmOpen(true);
  };

  const onDeleteSelected = () => {
    if (!selectedIds.length) return;
    setDeleteTarget({ type: "bulk" });
    setIsDeleteConfirmOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (!deleteTarget) return;

    if (deleteTarget.type === "single" && deleteTarget.leadId) {
      dispatch(deleteNewLeadAsync(deleteTarget.leadId)).then(() => {
        dispatch(getAllNewLeadsAsync(searchBy, searchText, audioType, batchFilter, fromDateFilter, toDateFilter, leadType, createdByFilter, "createdOn", "desc", callOutcomeFilter, companyNameFilter));
      });
    } else if (deleteTarget.type === "bulk" && selectedIds.length) {
      dispatch(deleteSelectedNewLeadsAsync(selectedIds)).then(() => {
        setCheckedVal(false);
        setSelectedIds([]);
        dispatch(getAllNewLeadsAsync(searchBy, searchText, audioType, batchFilter, fromDateFilter, toDateFilter, leadType, createdByFilter, "createdOn", "desc", callOutcomeFilter, companyNameFilter));
      });
    }

    setIsDeleteConfirmOpen(false);
    setDeleteTarget(null);
  };

  const handleDeleteCancel = () => {
    setIsDeleteConfirmOpen(false);
    setDeleteTarget(null);
  };

  // const onBulkCall = async () => {
  //   if (!selectedIds.length) {
  //     dispatch(showSuccessSnackbar("error", "Please select at least one lead to call.", 3000));
  //     return;
  //   }

  //   if (window.confirm(`Are you sure you want to initiate calls for ${selectedIds.length} selected lead(s)?`)) {
  //     const result = await dispatch(bulkCallAsync(selectedIds));
  //     if (result?.success) {
  //       setCheckedVal(false);
  //       setSelectedIds([]);
  //       dispatch(getAllColdLeadsAsync(searchBy, searchText, audioType, batchName, sortColumn, sortDirection));
  //     }
  //   }
  // };

  const handleSelectAll = () => {
    setCheckedVal(!checkedVal);
    if (!checkedVal) {
      // Only select non-blocked leads from filtered results
      const recordsToUse = filteredLeads.length > 0 ? filteredLeads : (coldLeadsList?.records || []);
      const nextIds =
        recordsToUse
          ?.filter((item) => item?.leadType !== "Blocked")
          ?.map((item) => item?._id)
          .filter(Boolean) || [];
      setSelectedIds(nextIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectOne = (event) => {
    const { id, checked } = event.target;
    // Find the lead to check if it's blocked
    const lead = coldLeadsList?.records?.find((item) => item?._id === id);
    if (lead?.leadType === "Blocked") {
      // Prevent selection of blocked leads
      event.preventDefault();
      return;
    }
    if (checked) {
      setSelectedIds((prev) => [...prev, id]);
    } else {
      setSelectedIds((prev) => prev.filter((item) => item !== id));
    }
  };

  const getLeadTypeStyle = (lt) => {
    switch (lt?.toLowerCase()) {
      case "unblock":
        return {
          color: "#28a745",
          fontWeight: "500",
        };
      case "blocked":
        return {
          color: "#dc3545",
          fontWeight: "500",
        };
      default:
        return {
          color: "#6c757d",
          fontWeight: "500",
        };
    }
  };

  const formatLeadType = (lt) => {
    if (!lt) return "-";
    return lt.charAt(0).toUpperCase() + lt.slice(1).toLowerCase();
  };

  const hasSelection = selectedIds.length > 0;

  const isViewAllow = useIsAccessAllow("new_data_call.view");
  const isDeleteAllow = useIsAccessAllow("new_data_call.delete");
  const isBulkDeleteAllow = useIsAccessAllow("new_data_call.multiple_delete");
  const isCallDetailsAllow = useIsAccessAllow("new_data_call.view");
  const isInitiateCallAllow = useIsAccessAllow("new_data_call.initiate_call");
  const isBulkCallAllow = useIsAccessAllow("new_data_call.initiate_call");


  // Fetch call statuses for all leads when call outcome filter is active
  useEffect(() => {
    // Clear call status cache when data changes so tooltips show fresh data
    setCallStatusCache({});
  }, [coldLeadsList]);

  const totalRecords = callOutcomeFilter && callOutcomeFilter !== "all"
    ? filteredLeads.length
    : (coldLeadsList?.recordsTotal || 0);
  const totalPages = Math.ceil(totalRecords / (limit || 1));
  const currentPage = skip + 1;

  return (
    <>
      <div className="px-6 pt-0 dash_wt_bx pb-0 ovflhddn loader-display-position" style={{ background: "#ffffff", borderRadius: "12px", padding: "24px", display: "flex", flexDirection: "column", height: "calc(100vh - 180px)", minHeight: "600px" }}>
        <div className="tblmrgn mt-0" style={{ display: "flex", flexDirection: "column", flex: "1 1 auto", minHeight: 0 }}>
          {(isBulkDeleteAllow || isBulkCallAllow) && (
            <div className="mt-4 mb-4" style={{ flex: "0 0 auto" }}>
              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                {isBulkCallAllow && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="bulk-call-tooltip">Bulk Call</Tooltip>}
                  >
                    <button
                      type="button"
                      className="custom-action-button button-success"
                      disabled={!hasSelection}
                      onClick={onBulkCallClick}
                      style={{ minWidth: "40px", padding: "8px" }}
                    >
                      <span className="svg-icon" style={{ color: "#ffffff" }}>
                        <SVG src={toAbsoluteUrl("/media/svg/icons/custom/Call.svg")} height={20} width={20} />
                      </span>
                    </button>
                  </OverlayTrigger>
                )}
                {isBulkDeleteAllow && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="bulk-delete-tooltip">Delete</Tooltip>}
                  >
                    <button
                      type="button"
                      className="custom-action-button button-danger"
                      disabled={!hasSelection}
                      onClick={onDeleteSelected}
                      style={{ minWidth: "40px", padding: "8px" }}
                    >
                      <span className="svg-icon" style={{ color: "#ffffff" }}>
                        <SVG src={toAbsoluteUrl("/media/svg/icons/custom/delete.svg")} height={20} width={20} />
                      </span>
                    </button>
                  </OverlayTrigger>
                )}
              </div>
            </div>
          )}
          <div className="table-container-wrapper" style={{ flex: "1 1 auto", minHeight: 0 }}>
            <div className="table-scroll-container">
              <Table hover className="mb-0 modern-table">
                <thead>
                  <tr>
                    {isBulkDeleteAllow && (
                      <th style={{ width: "50px", minWidth: "50px", maxWidth: "50px", whiteSpace: "nowrap" }}>
                        <label className="custom-checkbox-wrapper">
                          <Checkbox
                            type="checkbox"
                            name="checkAll"
                            id="checkAll"
                            handleClick={handleSelectAll}
                            isChecked={checkedVal}
                          />
                          <span className="custom-checkbox"></span>
                        </label>
                      </th>
                    )}
                    <th style={{ width: "70px", minWidth: "70px", maxWidth: "70px", whiteSpace: "nowrap" }}>
                      Sr No.
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>Batch</th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      Company Name
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>Client Name</th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      Client Company Name
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>Industry</th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      Contact Number
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      Country &amp; Time
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      Created By
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>
                      Created On
                    </th>
                    <th style={{ whiteSpace: "nowrap" }}>Lead Type</th>
                    <th style={{ whiteSpace: "nowrap", width: "220px", minWidth: "220px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {!isLoading && filteredLeads && filteredLeads.length ? (
                    filteredLeads.map((lead, index) => {
                      // Extract created by user name from various possible field structures
                      const createdByName = lead?.createdByName || lead?.created_by_name || "-";
                      // Consider call details available when the call detail button would render
                      const hasCallDetails = Boolean(lead?.elevenlabs_call_ai_id && lead?.elevenlabs_conversation_id);
                      // Check if lead is blocked
                      const isBlocked = lead?.leadType === "Blocked";
                      return (
                        <tr
                          key={lead?._id || index}
                          style={{
                            opacity: isBlocked ? 0.6 : 1,
                            cursor: isBlocked ? "not-allowed" : "default",
                          }}
                          onClick={(e) => {
                            // Prevent row selection when blocked
                            if (isBlocked) {
                              e.stopPropagation();
                            }
                          }}
                        >
                          {isBulkDeleteAllow && (
                            <td style={{ width: "50px", minWidth: "50px", maxWidth: "50px", whiteSpace: "nowrap" }}>
                              <label
                                className="custom-checkbox-wrapper"
                                style={{
                                  cursor: isBlocked ? "not-allowed" : "pointer",
                                  opacity: isBlocked ? 0.5 : 1,
                                }}
                                onClick={(e) => {
                                  if (isBlocked) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }
                                }}
                              >
                                <Checkbox
                                  type="checkbox"
                                  name={lead?._id}
                                  id={lead?._id}
                                  handleClick={(e) => {
                                    if (!isBlocked) {
                                      handleSelectOne(e);
                                    }
                                  }}
                                  isChecked={selectedIds.includes(lead?._id)}
                                  disabled={isBlocked}
                                />
                                <span className="custom-checkbox"></span>
                              </label>
                            </td>
                          )}
                          <td style={{ width: "70px", minWidth: "70px", maxWidth: "70px", whiteSpace: "nowrap" }}>
                            <span>{skip * limit + (index + 1)}</span>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            {lead?.BatchName || lead?.batch_name ? (
                              lead?.BatchName || lead?.batch_name
                            ) : (
                              <span>-</span>
                            )}
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <span className="profile-name">{lead?.CompanyName || "-"}</span>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <span className="profile-name">{lead?.ClientName || "-"}</span>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <div style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                              {isCallDetailsAllow && hasCallDetails ? (
                                <button
                                  type="button"
                                  onClick={() => onCallDetailsClick(lead)}
                                  className="profile-name clickable-name"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    padding: 0,
                                    margin: 0,
                                    color: "#3b82f6",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    fontSize: "inherit",
                                    fontWeight: "inherit",
                                  }}
                                >
                                  {lead?.ClientCompanyName || "-"}
                                </button>
                              ) : (
                                <span className="profile-name">{lead?.ClientCompanyName || "-"}</span>
                              )}
                              {(lead?.email || lead?.Email) && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`email-tooltip-${lead?._id || index}`}>
                                      {lead?.email || lead?.Email}
                                    </Tooltip>
                                  }
                                >
                                  <span
                                    className="svg-icon svg-icon-primary"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <SVG src={toAbsoluteUrl("/media/svg/icons/Communication/Mail.svg")} />
                                  </span>
                                </OverlayTrigger>
                              )}
                            </div>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            {(lead?.Industry != null && lead?.Industry !== "") || (lead?.Industrial != null && lead?.Industrial !== "") ? (
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id={`tooltip-industry-${lead?._id || index}`}>
                                    {lead?.Industry != null && lead?.Industry !== "" ? lead.Industry : lead.Industrial}
                                  </Tooltip>
                                }
                              >
                                <span
                                  style={{
                                    display: "inline-block",
                                    maxWidth: "220px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                    cursor: "help",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {lead?.Industry != null && lead?.Industry !== "" ? lead.Industry : lead.Industrial}
                                </span>
                              </OverlayTrigger>
                            ) : (
                              <span>-</span>
                            )}
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <span className="f-w-500">{lead?.ContactNumber || "-"}</span>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                              <span className="f-w-500">{lead?.countryName || "-"}
                                <br />{lead?.timezone ? lead?.timezone : " -"}</span>
                              <span className="f-w-500" style={{ fontSize: "0.875rem", color: "#6b7280" }}>
                                {lead?.currentCountryTime || "-"}

                              </span>
                            </div>
                          </td>

                          <td style={{ whiteSpace: "nowrap" }}>
                            <span>{createdByName || "-"}</span>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            <span>
                              {lead?.createdOn
                                ? (() => {
                                  const d = new Date(lead.createdOn);
                                  const dd = String(d.getDate()).padStart(2, "0");
                                  const mm = String(d.getMonth() + 1).padStart(2, "0");
                                  const yy = String(d.getFullYear()).slice(-2);
                                  const time = d.toLocaleTimeString(undefined, {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                  });
                                  return `${dd}/${mm}/${yy} ${time}`;
                                })()
                                : "-"}
                            </span>
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            {lead?.leadType ? (
                              <span style={getLeadTypeStyle(lead?.leadType)}>
                                {formatLeadType(lead?.leadType)}
                              </span>
                            ) : (
                              <span>{lead?.leadType || "-"}</span>
                            )}
                          </td>
                          <td style={{ whiteSpace: "nowrap", textAlign: "left", width: "220px", minWidth: "220px" }}>
                            <div className="inline-actions">
                              {isCallDetailsAllow && lead?.elevenlabs_call_ai_id && lead?.elevenlabs_conversation_id && (
                                <CallDetailsButtonWithStatus
                                  lead={lead}
                                  onCallDetailsPageClick={onCallDetailsPageClick}
                                  getCallStatus={getCallStatus}
                                />
                              )}
                              {isInitiateCallAllow && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`start-call-tooltip-${lead?._id || index}`}>
                                      {isBlocked ? "This lead is blocked" : "Start Call"}
                                    </Tooltip>
                                  }
                                >
                                  <button
                                    type="button"
                                    className="inline-action-btn"
                                    onClick={() => {
                                      if (!isBlocked) {
                                        onStartCallClick(lead);
                                      }
                                    }}
                                    disabled={isBlocked}
                                    style={{
                                      opacity: isBlocked ? 0.5 : 1,
                                      cursor: isBlocked ? "not-allowed" : "pointer",
                                    }}
                                  >
                                    <span className="svg-icon">
                                      <SVG src={toAbsoluteUrl("/media/svg/icons/custom/call-flat.svg")} />
                                    </span>
                                  </button>
                                </OverlayTrigger>
                              )}
                              {isViewAllow && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={<Tooltip id={`view-tooltip-${lead?._id || index}`}>View Details</Tooltip>}
                                >
                                  <button
                                    type="button"
                                    className="inline-action-btn"
                                    onClick={() => onViewClick(lead)}
                                  >
                                    <span className="svg-icon svg-icon-primary">
                                      <SVG src={toAbsoluteUrl("/media/svg/icons/custom/eye.svg")} />
                                    </span>
                                  </button>
                                </OverlayTrigger>
                              )}
                              {isDeleteAllow && (
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id={`delete-tooltip-${lead?._id || index}`}>
                                      {isBlocked ? "This lead is blocked" : "Delete Lead"}
                                    </Tooltip>
                                  }
                                >
                                  <button
                                    type="button"
                                    className="inline-action-btn danger"
                                    onClick={() => {
                                      if (!isBlocked) {
                                        onDeleteClick(lead);
                                      }
                                    }}
                                    disabled={isBlocked}
                                    style={{
                                      opacity: isBlocked ? 0.5 : 1,
                                      cursor: isBlocked ? "not-allowed" : "pointer",
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-danger">
                                      <SVG src={toAbsoluteUrl("/media/svg/icons/custom/delete.svg")} height={20} width={20} />
                                    </span>
                                  </button>
                                </OverlayTrigger>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={isBulkDeleteAllow ? 13 : 12} className="text-center">
                        {isLoading ? "Loading..." : callOutcomeFilter && callOutcomeFilter !== "all" && coldLeadsList?.records && coldLeadsList.records.length > 0
                          ? "No leads match the selected call outcome filter. Call statuses are being fetched..."
                          : "No Record Found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
          {!isLoading && (
            <div className="modern-pagination" style={{ flex: "0 0 auto" }}>
              <div className="pagination-info" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontSize: "14px", color: "#6b7280" }}>Show</span>
                  <Select
                    classNamePrefix="react-select"
                    value={defaultPageSize}
                    options={pageSizeOptions}
                    onChange={changePageSize}
                    isSearchable={false}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      container: (base) => ({
                        ...base,
                        width: 90,
                      }),
                      control: (base, state) => ({
                        ...base,
                        minHeight: 36,
                        height: 36,
                        borderColor: state.isFocused ? "#6993FF" : "#d1d5db",
                        boxShadow: state.isFocused ? "0 0 0 3px rgba(105, 147, 255, 0.1)" : "none",
                        "&:hover": {
                          borderColor: "#6993FF",
                        },
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        padding: "0 10px",
                        height: 36,
                        display: "flex",
                        alignItems: "center",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: 13,
                        fontWeight: 500,
                        color: "#111827",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                      dropdownIndicator: (base, state) => ({
                        ...base,
                        padding: 6,
                        color: state.isFocused ? "#6993FF" : "#6b7280",
                      }),
                      option: (base, state) => ({
                        ...base,
                        fontSize: 13,
                        padding: "8px 10px",
                        backgroundColor: state.isSelected
                          ? "#6993FF"
                          : state.isFocused
                            ? "#f3f4f6"
                            : "#fff",
                        color: state.isSelected ? "#fff" : "#111827",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </div>
                Showing {filteredLeads && filteredLeads.length ? skip * limit + 1 : 0} to{" "}
                {filteredLeads && filteredLeads.length ? Math.min(skip * limit + filteredLeads.length, totalRecords) : 0} of {totalRecords} entries
              </div>
              <div className="pagination-controls">
                <button className="page-btn" onClick={() => onPageChange(skip - 1)} disabled={skip === 0}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M10 12L6 8l4-4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                {(() => {
                  const pages = [];
                  if (totalPages > 0) pages.push(1);
                  for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
                    if (!pages.includes(i)) pages.push(i);
                  }
                  if (totalPages > 1 && !pages.includes(totalPages)) pages.push(totalPages);
                  return pages.map((page, idx) => {
                    const showEllipsisBefore = idx > 0 && page - pages[idx - 1] > 1;
                    return (
                      <React.Fragment key={page}>
                        {showEllipsisBefore && <span style={{ padding: "0 4px" }}>...</span>}
                        <button className={`page-btn ${currentPage === page ? "active" : ""}`} onClick={() => onPageChange(page - 1)}>
                          {page}
                        </button>
                      </React.Fragment>
                    );
                  });
                })()}
                <button
                  className="page-btn"
                  onClick={() => onPageChange(skip + 1)}
                  disabled={(skip + 1) * limit >= totalRecords}
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M6 12l4-4-4-4" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              </div>
            </div>
          )}
          {isLoading && (
            <div style={{ flex: "0 0 auto" }}>
              <div style={{ justifyContent: "center" }} className="text-center">
                <div className="basic-verification-loader text-center">
                  <CircularProgress />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        show={isBulkCallConfirmOpen}
        onHide={handleBulkCallCancel}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Bulk Call</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {`Are you sure you want to initiate calls for ${selectedIds.length} selected lead(s)? This will call each lead and retry once if the first call is not concluded.`}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleBulkCallCancel} disabled={isBulkCallLoading}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleBulkCallConfirm} disabled={isBulkCallLoading}>
            {isBulkCallLoading ? "Processing..." : "OK"}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isDeleteConfirmOpen}
        onHide={handleDeleteCancel}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {deleteTarget?.type === "bulk"
            ? `Are you sure you want to delete ${selectedIds.length} selected new data call record(s)?`
            : "Are you sure you want to delete this new data call record?"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteCancel}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDeleteConfirm}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isStartCallConfirmOpen}
        onHide={handleStartCallCancel}
        centered
        backdrop={isStartCallLoading ? "static" : true}
        keyboard={!isStartCallLoading}
      >
        <Modal.Header closeButton={!isStartCallLoading}>
          <Modal.Title>Confirm Call</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to initiate a call for this lead?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleStartCallCancel} disabled={isStartCallLoading}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleStartCallConfirm} disabled={isStartCallLoading}>
            {isStartCallLoading ? "Please wait..." : "OK"}
          </Button>
        </Modal.Footer>
      </Modal>
      <CallDetailsModal
        show={isCallModalOpen}
        onHide={closeCallDetailsModal}
        leadId={callDetailsLeadId}
      />
    </>
  );
};

export default NewLeadsTable;

